let skipPageEnter = false;

export const setSkipPageEnter = (value: boolean) => {
  skipPageEnter = value;
};

export const getSkipPageEnter = () => skipPageEnter;
